import React, { Component } from 'react';
import firebase from 'firebase';
import { Link } from 'react-router';
import FontAwesome from 'react-fontawesome';

import './LabelList.css';

class LabelList extends Component {
	constructor() {
		super();

		this.state = {
			addresses : [],
			userID : firebase.auth().currentUser.uid
		};

		this.addressesUpdated = this.addressesUpdated.bind(this);
	}

	componentWillMount() {
		firebase.database().ref('contacts/' + this.state.userID).on('value', this.addressesUpdated);
	}

	componentWillUnmount() {
		firebase.database().ref('contacts/' + this.state.userID).off('value', this.addressesUpdated);
	}

	addressesUpdated(snapshot) {
		let addresses = [];
		snapshot.forEach((item) => {
			let address = item.val();
			address.id = item.key;
			addresses.push(address);
		});
		this.setState({addresses});
	}

	printLabels() {
		window.print();
	}

	saveCSV(e) {
		let csv = '"nickname","address1","address2","city","state","zipcode"\r\n';
		for (let address of this.state.addresses) {
			csv += `"${address.nickname || address.firstName + ' ' + address.lastName}","${address.address1}","${address.address2 || '' }","${address.city}","${address.state}","${address.zip}"\r\n`;
		}
		const blob = new Blob([csv], { type: 'text/csv;charset=utf8;'});

		if (navigator.msSaveOrOpenBlob) {
	    navigator.msSaveOrOpenBlob(blob, 'labels.csv');
	  } else {
			const link = document.createElement('a');
			document.body.appendChild(link);
			link.setAttribute('href', window.URL.createObjectURL(blob));
			link.setAttribute('download','labels.csv');
			link.style.display = '';
			link.click();
			document.body.removeChild(link);
		}
		e.stopPropagation();
	}

  render() {
  	let addressLabels = [];
  	const pages = [];
  	let counter = 0;
  	for (let address of this.state.addresses) {
  		counter++;
  		// const nickname = (address.nickname ? <span className="address-line note">{address.nickname}</span> : null);
  		const addressee = (address.nickname ? <span className="address-line">{address.nickname}</span> : <span className="address-line">{address.firstName} {address.lastName}</span>);
  		const line2 = address.address2 ? <span className="address-line">{address.address2}</span> : null;
  		addressLabels.push(<li key={address.id} className="card address-label"><address className="card-block">{addressee}<span className="address-line">{address.address1}</span>{line2}<span className="address-line">{address.city}, {address.state} {address.zip}</span></address></li>);
  		if (addressLabels.length % 30 === 0) {
  			pages.push(<ul key={counter} className="labels">{addressLabels}</ul>);
  			addressLabels = [];
  		}
  	}
		if (addressLabels.length > 0) {
			pages.push(<ul key={counter} className="labels">{addressLabels}</ul>);
			addressLabels = [];
		}
  	// addressLabels.push(</ul>);

  	let rowCount = '';
  	if (this.state.addresses.length === 1) {
  		rowCount = 'You have 1 label.';
  	} else {
  		rowCount = `You have ${this.state.addresses.length} labels.`;
  	}

    return (
			<section id="address-labels-view" className="card">
				<div className="card-body">
					<h2 className="card-title">Address Labels</h2>
					<div className="subhead-toolbar">
						<h3 className="card-subtitle mb-2 text-muted">{rowCount}</h3>
						<div className="toolbar">
			        <button className="btn btn-primary" onClick={this.printLabels}><FontAwesome type="thin" name="print"/> Print Labels</button>
			        <button className="btn btn-outline-primary d-none d-md-block" onClick={this.saveCSV.bind(this)}><FontAwesome type="thin" name="download"/> Download CSV</button>
			        <Link to="/" className="btn btn-outline-primary d-none d-md-block"><FontAwesome type="thin" name="table"/> View as List</Link>
						</div>
					</div>


{/*		      <h2>Address Labels</h2>
		      <div className="row sub-heading">
			      <div className="col">
			      	{rowCount}
			      </div>
			      <div className="col align-right">
			      	<button className="btn btn-primary pointer" onClick={this.printLabels}><FontAwesome name="print"/> Print Labels</button>
			      	&nbsp;&nbsp;<Link to="/" className="btn btn-outline-primary"><FontAwesome name="table"/> View as List</Link>
			      </div>
		      </div>
		      */}
					{pages}
				</div>
			</section>
    );
  }
}

export default LabelList;



// WEBPACK FOOTER //
// ./src/components/LabelList.js